'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InterpretationItem = undefined;

var _InterpretationWindow = require('./InterpretationWindow');

var InterpretationItem = exports.InterpretationItem = undefined;

exports.InterpretationItem = InterpretationItem = function InterpretationItem(c) {
    var instanceManager = c.instanceManager,
        i18nManager = c.i18nManager,
        i18n = c.i18nManager.get();

    return Ext.create('Ext.menu.Item', {
        text: i18n.write_interpretation + '&nbsp;&nbsp;',
        iconCls: 'ns-menu-item-tablelayout',
        disabled: true,
        xable: function xable() {
            this.setDisabled(!instanceManager.isStateSaved());
        },
        handler: function handler() {
            (0, _InterpretationWindow.InterpretationWindow)(c).show();
        }
    });
};
//# sourceMappingURL=InterpretationItem.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/ui/InterpretationItem.js
 ** module id = 62
 ** module chunks = 0 1
 **/